import {
  Dialog,
  DialogContent,
  CircularProgress,
  Stack,
  Typography
} from '@material-ui/core';

const DialogLoading = ({ open }) => {
  return (
    <Dialog open={open} fullWidth maxWidth='xs'>
      <DialogContent>
        <Stack direction="column" justifyContent="center" alignItems="center" spacing={1}>
          <Typography>Loading</Typography>
          <CircularProgress size={35}/>
        </Stack>
      </DialogContent>
    </Dialog>
  )
}

export default DialogLoading